import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { JiraIssueCreateErrorBoundary } from '@jira/issue-create__issue-create-analytics-common/src/ui/jira-issue-create-error-boundary/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { BackgroundPriority } from '@jira/platform__services-non-critical/src/BackgroundPriority.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { preloadableAsyncRichTextEditEntryPoint } from '@jira/issue__field-rich-text/src/preloadableAsyncRichTextEditEntryPoint.entrypoint.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const IssueCreateModernisedModalLazy = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-issue-create-modernised-modal" */ './IssueCreateModernisedModal.tsx'
		),
	{ ssr: false },
);

export const preloadIssueCreateModernisedModal = (): void => {
	IssueCreateModernisedModalLazy.preload();
	if (fg('jira_wic_preload_editor_hover')) {
		preloadableAsyncRichTextEditEntryPoint.preload();
	}
};

type AsyncIssueCreateModernisedModalProps = {
	onResetApolloCache?: () => void;
	alwaysShowFullForm?: boolean;
};

const IssueCreateModernisedModalWithPriority = ({
	onResetApolloCache,
	alwaysShowFullForm,
}: AsyncIssueCreateModernisedModalProps) => (
	<BackgroundPriority>
		<IssueCreateModernisedModalLazy
			onResetApolloCache={onResetApolloCache}
			alwaysShowFullForm={alwaysShowFullForm}
		/>
	</BackgroundPriority>
);

export const AsyncIssueCreateModernisedModal = ({
	onResetApolloCache,
	alwaysShowFullForm,
}: AsyncIssueCreateModernisedModalProps): React.JSX.Element => (
	<JiraIssueCreateErrorBoundary
		id="async.jira.issue-create-modernised-modal"
		packageName="jiraIssueCreateModernised"
		sendToPrivacyUnsafeSplunk
	>
		<Placeholder name="issue-create-modernised-modal" fallback={<></>}>
			<IssueCreateModernisedModalWithPriority
				onResetApolloCache={onResetApolloCache}
				alwaysShowFullForm={alwaysShowFullForm}
			/>
		</Placeholder>
	</JiraIssueCreateErrorBoundary>
);
